import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton'; // @ts-expect-error module is untyped

import MobilePanel from 'ecosystem-marketplace-core/js/components/mobile/MobilePanel';
import MobilePanelBody from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelBody';
import MobilePanelHeader from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelHeader';
import MobilePanelNavItem from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelNavItem';
import { useFocusTrap } from 'ecosystem-marketplace-core/hooks/useFocusTrap';
import MobileDiscoverPanel from './MobileDiscoverPanel';
import { getModulesStorefrontRoute, getThemesStorefrontRoute } from '../../../utils/urls'; // @ts-expect-error untyped module

import { getIsUngatedForModulesStorefront } from '../../../selectors/auth';
const StyledHeaderAction = styled(UIButton).withConfig({
  displayName: "MobileBrowsePanel__StyledHeaderAction",
  componentId: "sc-1439zes-0"
})(["&&&&{padding:4px;}"]);
export default function MobileBrowsePanel({
  onClose,
  open
}) {
  const history = useHistory();
  const [isDiscoverPanelOpen, setIsDiscoverPanelOpen] = useState(false);
  const mobileBrowsePanelButtonRef = useRef(null);
  const isUngatedForModulesStorefront = useSelector(getIsUngatedForModulesStorefront);

  const handleNavItemClick = to => {
    setIsDiscoverPanelOpen(false);
    onClose();
    history.push(to);
  };

  useFocusTrap(open);
  return /*#__PURE__*/_jsxs(MobilePanel, {
    align: "bottom",
    open: open,
    children: [/*#__PURE__*/_jsx(MobilePanelHeader, {
      itemLeft: /*#__PURE__*/_jsx(StyledHeaderAction, {
        autoFocus: true,
        buttonRef: mobileBrowsePanelButtonRef,
        className: "m-left-2",
        use: "transparent",
        onClick: onClose,
        tabIndex: 0,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.browsePanel.cancel"
        })
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.storefront.browsePanel.title"
      })
    }), /*#__PURE__*/_jsxs(MobilePanelBody, {
      children: [isUngatedForModulesStorefront ? null : /*#__PURE__*/_jsx(MobilePanelNavItem, {
        onClickItem: () => setIsDiscoverPanelOpen(true),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.nav.discover"
        }),
        children: /*#__PURE__*/_jsx(MobileDiscoverPanel, {
          onClose: () => {
            setIsDiscoverPanelOpen(false);
            mobileBrowsePanelButtonRef.current.focus();
          },
          onClickItem: handleNavItemClick,
          open: isDiscoverPanelOpen
        })
      }), /*#__PURE__*/_jsx(MobilePanelNavItem, {
        onClickItem: () => handleNavItemClick(getThemesStorefrontRoute('all')),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.nav.themes"
        })
      }), isUngatedForModulesStorefront ? /*#__PURE__*/_jsx(MobilePanelNavItem, {
        onClickItem: () => handleNavItemClick(getModulesStorefrontRoute()),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.storefront.nav.modules"
        })
      }) : null]
    })]
  });
}